import Checkboxes from './Checkboxes';
export default Checkboxes;